console.log("site-child.js");

// css
import '../scss/style.scss'
//import '../scss/woocommerce/scss/woocommerce.scss'

// page builder framework theme js
import './modules/page-builder-framework.js';

// slick carousel
import slick from 'slick-carousel';

import carouselSlider from './modules/slick-carousel.js';
var carousel = new carouselSlider();

import carouselSliderProductsRow from './modules/slick-carousel-products-row.js';
var carouselRow = new carouselSliderProductsRow();

import carouselSliderRelated from './modules/slick-carousel-related.js';
var carouselRelated = new carouselSliderRelated();

/*
import carouselSlider from './modules/slick-carousel.js';
var carousel = new carouselSlider();
import carouselSliderProducts from './modules/slick-carousel-products.js';
var carouselProduct = new carouselSliderProducts();
import carouselSliderRelated from './modules/slick-carousel-related.js';
var carouselRelated = new carouselSliderRelated();
*/

// non va tramite modulo es6
/*
import carouselSliderGallery from './modules/slick-carousel-gallery.js';
var carouselGallery = new carouselSliderGallery();
*/

// cookie consent js
//console.log("cookieconsent.min.js");
//import './modules/cookieconsent.min.js';

(function ($) {

	// Add your custom scripts here.
	// This file will be compiled and is part of the gulp workflow.
	// If you're not using gulp, please make your changes directly to the site-child.js file in the main js folder.

	//SHOW SHIPPING PLUGIN GIFT AFTER SCROLLING	
	$(document).scroll(function () {
		
		var y = $(this).scrollTop();
		if (y > 200) {
				$('.wfspb-gift-box').addClass('on');
			} else {
			$('.wfspb-gift-box').removeClass('on');
		}		
		
	});

	
	$(document).ready(function () {

		//THUMBS GALLERY SLIDER
		$('.flex-control-nav').slick({ autoplay: true, slidesToShow: 5, slidesToScroll: 1, arrows: true, infinite: false });
		
		//COOKIECONSENT
		/*
		window.cookieconsent.initialise({
			"palette": {
				"popup": {
					"background": "#000000",
					"text": "#ffffff"
				},
				"button": {
					"background": "#ac8500",
					"text": "#ffffff"
				}
			},
			"theme": "edgeless",
			"content": {
				"message": "Utilizziamo cookie tecnici e di non profilazione per assicurarti una migliore esperienza sul sito. Se prosegui nella navigazione acconsenti all'utilizzo dei Cookie. Per maggiori informazioni sui cookie e sulla loro disabilitazione consulta la:  ",
				"dismiss": "ok",
				"link": "cookie policy",
				"href": "https://dmc12.pensareweb.it/cookie_policy/"
			}
		});
		*/
		
	});

})(jQuery);


// LINK PER APRIRE IL BOX COUPON DAL FOOTER 
jQuery( document ).ready(function() {
	
	jQuery('.prdctfltr_widget_title').trigger('click');
				
	jQuery('#sub_newsletter').on('click', function(){
	    jQuery('.wcb-coupon-box-small-icon-wrap').trigger('click');
	});
	
});

// APRO E CHIUDO I FILTRI NELLA SIBEAR A SECONDA DELLA RISOLUZIONE
window.onresize = apriChiudiFiltri;

function apriChiudiFiltri() {

	if (jQuery(window).width() < 768 && jQuery('#sidebar i.prdctfltr-up').length>0 && jQuery('#sidebar span.prdctfltr_widget_title').length>0) {
	   jQuery('#sidebar i.prdctfltr-up').closest('span.prdctfltr_widget_title').trigger('click');
	}
	else if(jQuery(window).width() >= 768 && jQuery('#sidebar i.prdctfltr-down').length>0 && jQuery('#sidebar span.prdctfltr_widget_title').length>0) {
	   jQuery('#sidebar i.prdctfltr-down').closest('span.prdctfltr_widget_title').trigger('click');
	}

}

jQuery("select[id=pa_taglia] option:first").text("Scegli un numero");
jQuery("select[id=pa_colore] option:first").text("Scegli un colore");

